import { Injectable, signal } from '@angular/core';
import { filter, interval } from 'rxjs';

import { environment } from '../../../environment/environment';

@Injectable({
	providedIn: 'root',
})
export class PollService {
	private _stopPoll = signal(false);

	constructor() {
		this.setPollingState(document.visibilityState === 'hidden');

		document.addEventListener('visibilitychange', () => {
			this.setPollingState(document.visibilityState === 'hidden');
		});
	}

	private setPollingState(isDocumentVisible: boolean) {
		if (isDocumentVisible) {
			this._stopPoll.set(true);
		} else {
			this._stopPoll.set(false);
		}
	}

	getPoll() {
		let pollingInterval = environment.appApiPollingInterval;

		// Note: Polling interval is set to 1 minute by default in case we have
		// delay in fetching the config or the value is less than 500ms
		if (!pollingInterval || pollingInterval <= 500) {
			pollingInterval = 60000;
		}

		return interval(pollingInterval).pipe(filter(() => !this._stopPoll()));
	}
}
